// Vendors
import { EventEmitter } from "events";

export class EventBus {
    public static emmiter: EventEmitter = new EventEmitter();

    public static emit(eventName: string, data?: any): void {
        if (data) {
            this.emmiter.emit(eventName, data)
            return;
        }

        this.emmiter.emit(eventName);
    }

}